module.exports = __webpack_public_path__ + "static/media/Figure-8-Creative.08f23994.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screenshots/Figure-8-Creative.png
// module id = 93
// module chunks = 0